import { addLoadingState, changeSubTask, initIndexDBSuccess, loginSuccess, logoutSuccess, nologin, removeLoadingState, routeAction, updateInternetOffline } from "./spa-app-actions.js";
import { on, reducer } from "ts-action";
//#region src/store/spa-app-reducer.ts
var initialState = {
	loadingState: [],
	userLoginDone: false,
	user: void 0
};
var spaAppReducer = reducer(initialState, on(updateInternetOffline, (state, { payload }) => ({
	...state,
	offline: payload
})), on(addLoadingState, (state, { payload }) => ({
	...state,
	loadingState: [...state.loadingState, payload]
})), on(changeSubTask, (state, { payload }) => ({
	...state,
	loadingState: state.loadingState.map((ls) => {
		if (ls.actionKey === payload.loadingActionId) return {
			...ls,
			subTask: ls.subTask?.map((subLs) => subLs.actionKey === payload.newTaskState.actionKey ? payload.newTaskState : subLs)
		};
		return ls;
	})
})), on(removeLoadingState, (state, { payload }) => ({
	...state,
	loadingState: state.loadingState?.filter((a) => a.actionKey !== payload)
})), on(routeAction, (state, { payload }) => ({
	...state,
	lastRoutes: [...state.lastRoutes || [], payload]
})), on(initIndexDBSuccess, (state) => ({
	...state,
	initIndexDB: true
})), on(loginSuccess, (state, { payload }) => ({
	...state,
	userLoginDone: true,
	user: payload
})), on(nologin, (state) => ({
	...state,
	userLoginDone: true,
	user: void 0
})), on(logoutSuccess, () => ({
	...initialState,
	userLoginDone: true,
	user: void 0
})));
//#endregion
export { spaAppReducer };
